import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./setUpTalGel";
import GelThemes from "./gelThemes";
import { ThemeContextProvider } from "./common/authentication/themes.context";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Only run axe in development
if (process.env.NODE_ENV !== 'production') {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 10000);
  });
}

const IndexPage = () => {
  return (
    <ThemeContextProvider>
      <GelThemes />
    </ThemeContextProvider>
  );
};

root.render(
  <HelmetProvider>
    <IndexPage />
  </HelmetProvider>
);

reportWebVitals();
